import { useEffect } from 'react'

/**
 *
 * @param {null | ref } ref - set as null or false to attach to 'root' div.
 * @param script
 */
export const useExternalScriptTag = ({ ref, script }) => {
  if (!ref) ref = { current: document.getElementById('root') }

  useEffect(() => {
    if (!ref.current) return

    const scriptElement = document.createElement('script')
    scriptElement.type = 'text/javascript'
    scriptElement.async = true
    scriptElement.innerHTML = script

    ref.current.appendChild(scriptElement)
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ref.current?.removeChild(scriptElement)
    }
  }, [ref, script])
}
